module.exports = __webpack_public_path__ + "img/report-7.5d664db5.jpg";